import { density } from '@microsoft/fast-components';
// export const baseHeightMultiplierValue = 10;
export const controlCornerRadiusValue = 4;
export const densityValue = density.getValueFor(density.appliedTo[0]);
export const designUnitValue = 4;
